import {
  StatusEnum,
  ControlTypeEnum,
  ControlTypeOptionsEnum,
  AlignEnum,
  CharactersEnum,
  FormatFunctionEnum,
  QuestionEnum,
  FieldFormEnum,
  TableReferenceEnum,
  ConvertTextEnum,
  FieldTypeEnum,
  ConvertViewEnum,
} from '@helpers/enums';
import { ITimestamp } from '../iTimestamp';
import moment from 'moment';
import { IOptionsField } from './iOptionsField';
import { IOption } from '../generals/iOption';
import PivotClass, { IPivot } from '../generals/iPivot';
import { ITable } from './iTable';
import { IEntitiesType } from '../core/iEntitiesType';
import { IFieldsPrefix } from './iFieldsPrefix';
import { ISection } from './iSection';

export interface IField extends ITimestamp {
  id: number | null;
  status: StatusEnum;
  type_field: FieldTypeEnum;
  table_reference: TableReferenceEnum;
  title: string;
  field_name: string;
  width: number | null;
  visible: boolean;
  print_type: string;
  control_type: ControlTypeEnum | null;
  control_type_options: ControlTypeOptionsEnum | null;
  field_filtered_id: number | null;
  align: AlignEnum;
  characters: CharactersEnum | null;
  max_value: number | null;
  min_value: number | null;
  max_length: number | null;
  min_length: number | null;
  format_function: FormatFunctionEnum | null;
  regular_expression: string | null;
  unique_creation: QuestionEnum;
  creatable: FieldFormEnum;
  convert_text: ConvertTextEnum;
  convert_view: ConvertViewEnum;
  editable: FieldFormEnum;
  table_id: number | null;
  options_fields: IOptionsField[];
  selectOption: IOption[];
  options: IOptionsField[];
  pivot: IPivot;
  table: ITable | null;
  fields_sections: IField[];
  sections: ISection[];
  entities_types: IEntitiesType[];
  fields_prefixes: IFieldsPrefix[];
  selected: QuestionEnum;
  selectFields: IField[];
  mappingName: String;
  file_extensions: string;
  max_files: number;
  file_max_size: number;
  col_separator: string | null;
  row_separator: string | null;
  semicolon_separated_headers: string | null;
}

class FieldClass implements IField {
  id;
  status;
  type_field = FieldTypeEnum.ENTITY;
  table_reference = TableReferenceEnum.ENTITIES;
  title;
  field_name;
  width;
  visible;
  print_type;
  control_type;
  control_type_options;
  align;
  field_filtered_id: number | null = null;
  characters;
  max_value = null;
  min_value = null;
  max_length = null;
  min_length = null;
  format_function = null;
  regular_expression = null;
  unique_creation = QuestionEnum.NO;
  creatable = FieldFormEnum.NO;
  convert_text = ConvertTextEnum.UPPERCASE;
  convert_view = ConvertViewEnum.NO;
  editable = FieldFormEnum.NO;
  table_id = null;
  created_at = moment().format('YYYY-MM-DD');
  updated_at = null;
  options_fields;
  options = [];
  selectOption = [];
  pivot = new PivotClass();
  table = null;
  sections = [];
  fields_sections = [];
  entities_types = [];
  fields_prefixes: IFieldsPrefix[] = [];
  selected: QuestionEnum = QuestionEnum.NO;
  selectFields = [];
  mappingName: String = '';
  file_extensions: string = '';
  max_files: number = 1;
  file_max_size: number = 1;
  col_separator = '';
  row_separator = '';
  semicolon_separated_headers = '';
  constructor(
    id?: number | null,
    title?: string,
    field_name?: string,
    align?: AlignEnum,
    print_type?: string,
    width?: number | null,
    visible?: boolean,
    control_type?: ControlTypeEnum,
    control_type_options?: ControlTypeOptionsEnum | null,
    characters?: CharactersEnum | null,
    options_fields?: IOptionsField[],
  ) {
    this.id = id ?? null;
    this.status = StatusEnum.ACTIVE;
    this.title = title ?? '';
    this.field_name = field_name ?? '';
    this.align = align ?? AlignEnum.CENTER;
    this.print_type = print_type ?? '';
    this.width = width ?? null;
    this.visible = visible ?? true;
    this.control_type = control_type ?? ControlTypeEnum.INPUT_TEXT;
    this.control_type_options = control_type_options ?? ControlTypeOptionsEnum.OPTIONS_LIST;
    this.characters = characters ?? null;
    this.options_fields = options_fields ?? [];
  }

  static setNewlyCreated(created_at: string | null): boolean {
    if (created_at) {
      let newDate = moment();
      let dateField = moment(created_at);
      if (newDate.diff(dateField, 'minutes') < 6) {
        return true;
      }
    }
    return false;
  }
}

export default FieldClass;
